import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchHot100IfNeeded, fetchHot100Position  } from '~/features/actions'
import { AnimationOnScroll } from 'react-animation-on-scroll';

class Hot100 extends React.Component {
  constructor() {
    super();
    let h100Timeout = null
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimeOut)
    clearTimeout(this.h100Timeout)
  }

  componentDidMount() {
    const { match, history } = this.props
    var _this = this
    function getTitle(_this) {
      _this.getPosition()
      _this.h100Timeout = setTimeout(getTitle, 30000, _this)
    }
    this.h100Timeout = setTimeout(getTitle, 1000, this)
  }

  getPosition() {
    const { dispatch } = this.props
    dispatch(fetchHot100Position())
  }

  getData() {
    const { dispatch } = this.props
    dispatch(fetchHot100IfNeeded())
  }


  render() {
    const { hot100 } = this.props

    if (hot100.items.length > 0) {
      return(
      <div className="hot100-feature">
        <div className="margin">
          <Link to="/hot100">
            <div className="wrap">
            <div className="text">
              <div class="hot-100-logo sticker" />
            </div>
            <div className="items">
              <div className="section single">
                  <div className="listing">
                    <div className="number">{hot100.items[0]["Rank"]}</div>
                    <div className="artist">{hot100.items[0]["Artist"]}</div>
                    <div className="title">{hot100.items[0]["Track"]}</div>
                  </div>
                </div>
            </div>
            </div>
          </Link>
        </div>
      </div>
      )
    }
    else {
      return (
        <div>
        </div>
      )
    }
  }
}

export default connect(state => { return { hot100: state.hot100 }}) (Hot100)
